import type { DocumentKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';

const useDocumentText = () => {
  const { t } = useTranslation('common', { keyPrefix: 'id_document' });
  const map: Record<DocumentKind, string> = {
    id_card: t($ => $.id_card),
    drivers_license: t($ => $.drivers_license),
    passport: t($ => $.passport),
    visa: t($ => $.visa),
    permit: t($ => $.permit),
    residence_document: t($ => $.residence_document),
    voter_identification: t($ => $.voter_identification),
    ssn_card: t($ => $.ssn_card),
    // @ts-expect-error: backend needs to add
    lease: t($ => $.lease),
    bank_statement: t($ => $.bank_statement),
    utility_bill: t($ => $.utility_bill),
    proof_of_address: t($ => $.proof_of_address),
    passport_card: t($ => $.passport_card),
    selfie: t($ => $.selfie),
    custom: t($ => $.passport_card),
  };

  return (documentKind: DocumentKind) => {
    return map[documentKind];
  };
};

export default useDocumentText;
